<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			height="60vh"
		>
			<!-- <el-table-column type="selection" width="55"> </el-table-column> -->

			<el-table-column prop="id" label="序号" width="100"> </el-table-column>
			<el-table-column prop="account" label="账号"> </el-table-column>
			<el-table-column prop="truename" label="姓名"> </el-table-column>
			<el-table-column prop="role_name" label="角色"> </el-table-column>

			<el-table-column prop="mobile" label="手机号码" width="200">
			</el-table-column>

			<el-table-column fixed="right" label="操作">
				<template slot-scope="scope">
					<span class="pointer" @click="toDelete(scope.row)">删除</span>
					<span class="pointer margin_left_10" @click="logout(scope.row)">
						退出登录
					</span>
					<span class="pointer margin_left_10" @click="toEdit(scope.row)">
						编辑
					</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { delAccount, logoutAccount } from "@/api/limitsauthority";
export default {
	props: ["tableData"],
	name: "",
	data() {
		return {
			value: true,
		};
	},
	methods: {
		toEdit(row) {
			this.$router.push({
				path: "/limitsauthority/addpersonnel",
				query: { id: row.id, type: "edit" },
			});
		},
		logout(row) {
			this.$confirm("此操作将退出该人员登录, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					logoutAccount({ id: row.id }).then((res) => {
						if (res.code == 200) {
							this.$message({
								type: "success",
								message: "踢出登录成功!",
							});
							this.$parent.$parent.getDataList();
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		toDelete(row) {
			this.$confirm("此操作将删除该人员, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					delAccount({ id: row.id }).then((res) => {
						if (res.code == 200) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.$parent.$parent.getDataList();
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
	},
};
</script>

<style scoped></style>
